export default "__VITE_ASSET__BazUE2g3__"